import React from 'react'

export default () => (
    <div>
        <h3 className="text-warning">Professional Strengths</h3>
        <p className="pl-2">Frontend: <strong>HTML5, CSS3, Bootstrap, FlexboxJavascript, jQuery, ReactJS</strong></p>
        <p className="pl-2">Others: <strong>JSON</strong></p>
    </div>

)